import { Injectable } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  AllocationViewRegisterNewTruckAction,
  AllocationViewRegisterNewTruckSetInitialState,
} from './allocation-view-register-new-truck-action.actions';
import { AllocationViewRegisterNewTruckActionState } from './allocation-view-register-new-truck-action.state';
import { AllocationViewActionInterface } from '../models';
import { AllocationViewActionsFacade } from '../allocation-view-actions.facade';
import { AllocationViewSelectedEntityModel } from '../../models';

@Injectable({ providedIn: 'root' })
export class AllocationViewRegisterNewTruckActionFacade implements AllocationViewActionInterface {
  loaded$: Observable<boolean> = this.store.select(AllocationViewRegisterNewTruckActionState.getLoaded);

  constructor(private allocationViewActionsFacade: AllocationViewActionsFacade, private store: Store) {}

  execute(): void {
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ identifier }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(
          new AllocationViewRegisterNewTruckAction({
            identifier,
          }),
        );
      });
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewRegisterNewTruckSetInitialState());
  }
}
